import React, { Component, useCallback, useEffect, useMemo, useState } from 'react';
import * as d3 from "d3";
import Rect from './widget/rect'
import Search from './widget/search'

function Widget(props) {
    const root = props.root
    const format = props.format
    const retrieve = props.retrieve
    const data = props.data
    const nodes = props.nodes
    const edges = props.edges
    let extraNodes = props.extraNodes
    const setExtraNodes = props.setExtraNodes
    const color = props.color
    const updateNetwork = props.updateNetwork
    const [search, setSearch] = useState()
    const originalRects = data;
    const [selected, setSelected] = useState(false);
    let [selectedNodes, setSelectedNodes] = useState([]);
    let [selectedRects, setSelectedRects] = useState([]);
    let [unSelectedRects, setUnSelectedRects] = useState([]);
    let [rects, setRects] = useState([]);
    unSelectedRects = selectedRects.length === 0 ? data : unSelectedRects;
    rects = [...selectedRects,...unSelectedRects];

    function allNodes(rects) {
        let allNodes = [];
        rects.forEach(node => allNodes.push({name: node.code, cases: node.cases, core: node.core}));
        return allNodes;
    }

    function addNodes(selectedNodes) {
        extraNodes = [...extraNodes,...selectedNodes];
        setExtraNodes(extraNodes);
        setSelectedNodes([]);
        updateNetwork(edges, nodes, extraNodes);
        closeWidget();
    }

    function closeWidget() {
        setSearch('');
        setSelectedRects([]);
        setUnSelectedRects(data);
        setSelectedNodes([]);
        props.setTrigger(false);
    }

    function filterWidget(search) {
        var startsWith = []
        var includesIt = []
        var currentData = unSelectedRects;
        if (search !== undefined) {
            currentData.forEach(el => {
                if (el.code.toLowerCase().startsWith(search.replaceAll(' ', '_')) || el.longname.toLowerCase().startsWith(search)) {
                    startsWith.push(el)
                    currentData = currentData.filter(e => e.longname !== el.longname)
                }
            })
            currentData.forEach(el => {
                if (el.code.toLowerCase().includes(search.replaceAll(' ', '_')) || el.longname.toLowerCase().includes(search)) {
                    includesIt.push(el)
                }
            })
            unSelectedRects = startsWith.concat(includesIt);
            rects = [...selectedRects,...unSelectedRects];
        }
        return rects;
    }

    var dep1 = JSON.stringify(selectedNodes)
    var dep2 = JSON.stringify(rects)
    var dep3 = JSON.stringify(extraNodes)

    useEffect(()=> {
        setExtraNodes(extraNodes)
    }, [dep1, dep2, dep3])

    return (props.trigger) ? (
        <div className = "widget_container" style={{ right: '42%', top: '120px' }}>
            <div id = "widget_header">
                <p className = "n_longname">{format.longname(retrieve.longname(root.name))}</p>   
                <button onClick = {() => closeWidget()} id = "widget_close">×</button> 
            </div>
            <div id = "w_cases">
                <h2><span style={{ fontSize: 12 + 'px', fontWeight: 400}}>Cases:&nbsp;</span> {format.count(root.cases)}</h2>    
            </div>
            <div style = {{marginTop: '4px', backgroundColor: 'var(--background)'}} id="network_search_container">
                <Search
                search={search} 
                setSearch={setSearch}/>
            </div>
            <div id = "distance_filter_svg"></div>
            <div id = 'w_container'>
            {filterWidget(search).map((node,n) => 
                <Rect 
                    key={n} 
                    node = {node} 
                    selected = {selectedRects.includes(node)}
                    setSelected = {setSelected}
                    extraNodes = {extraNodes}
                    setExtraNodes = {setExtraNodes}
                    status = {node.status} 
                    longname = {node.longname} 
                    code = {node.code} 
                    distance = {node.distance} 
                    cases = {node.cases} 
                    core = {node.core}
                    color = {color} 
                    format = {format} 
                    selectedNodes = {selectedNodes} 
                    setSelectedNodes = {setSelectedNodes} 
                    selectedRects = {selectedRects} 
                    setSelectedRects = {setSelectedRects} 
                    unSelectedRects = {unSelectedRects}
                    setUnSelectedRects = {setUnSelectedRects}
                    originalRects = {originalRects}
                    updateNetwork = {updateNetwork}
                    search = {search}
                >
                </Rect>
            )}       
            </div>
            <div id = "w_button_container">
                <p style = {{paddingRight: '4px', cursor: 'pointer'}} onClick = {() => addNodes(allNodes(rects))} id = "add-all" className = "n_longname">Add all +</p>
                <button style = {{backgroundColor: selectedNodes.length === 0 ? 'transparent' : color.lightpurple}} className = "w_add_button" id = "add_nodes" onClick = {() => addNodes(selectedNodes)}>ADD {selectedNodes.length} {selectedNodes.length === 1 ? 'ENDPOINT' : 'ENDPOINTS'}</button>
            </div>
        </div>
    ) : "";
}

export default Widget